import type { TourStepData } from './types';

export const contentCalendarTourSteps: TourStepData[] = [
  {
    target: '[data-tour="content-calendar-header"]',
    title: 'Content Calendar',
    content:
      'Le Content Calendar (Calendrier editorial) planifie et suit les publications marketing. Creez des entrees, definissez des dates de publication et suivez l\'avancement.',
    placement: 'bottom',
    glossaryTerm: 'content-calendar',
  },
  {
    target: '.fc-card',
    title: 'Barre d\'outils',
    content:
      'Naviguez entre les mois, basculez en vue semaine/mois et ajoutez de nouvelles entrees editoriales.',
    placement: 'bottom',
  },
  {
    target: '.grid',
    title: 'Grille calendrier',
    content:
      'Chaque case represente un jour. Les entrees sont affichees avec un code couleur par statut : brouillon (Draft), planifie ou publie (Published).',
    placement: 'top',
  },
];
